var map = {
	"./independenceFive.svg": 3687,
	"./independenceFour.svg": 1191,
	"./independenceOne.svg": 5253,
	"./independenceSix.svg": 7073,
	"./independenceThree.svg": 1097,
	"./independenceTwo.svg": 8411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7556;